import { trans } from "@mongez/localization";
import { settingsAtom } from "core/shared";
import {
  ColoredEmailIcon,
  ColoredPhoneIcon,
} from "~/design-system/components/icons/contact-us-icons";

export function ContactMethods() {
  const data = settingsAtom.use("contact");

  const contactMethods = [
    {
      Icon: ColoredEmailIcon,
      text: "contactUsPage.emailAddress",
      href: `mailto:${data?.email}`,
      value: data?.email,
    },
    {
      Icon: ColoredPhoneIcon,
      text: "contactUsPage.phoneNumber",
      href: `tel:${data?.phoneNumber}`,
      value: data?.phoneNumber,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-8 lg:gap-[4.75rem]">
      {contactMethods.map((method, index) => (
        <div
          key={index}
          className="border-night flex flex-col items-center justify-center gap-4 rounded-2xl border bg-white/30 py-4 sm:gap-6 sm:rounded-3xl sm:py-5 lg:gap-8 lg:py-6"
        >
          <method.Icon />

          <h4 className="text-night text-center text-lg font-medium sm:text-xl lg:text-xl">
            {trans(method.text)}
          </h4>
          <a
            href={method.href}
            className="hover:text-primary-600 text-center text-sm font-semibold text-gray-900 transition-colors duration-200 sm:text-base lg:text-xl xl:text-2xl"
          >
            {method.value}
          </a>
        </div>
      ))}
    </div>
  );
}
